import React from "react"
import { useTranslation } from "react-i18next"

import { Icon } from "shared/ui/icon/Icon"
import { IconName } from "shared/ui/icon/__generated__/IconName"

import "assets/stylesheets/ui-kit/inputs/_input.scss"

import "features/global-search/ui/global-search/styles/_global-search.scss"

interface GlobalSearchButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  isIconOnly?: boolean
}

export const GlobalSearchButton = React.memo(
  React.forwardRef(
    (
      { isIconOnly, ...props }: GlobalSearchButtonProps,
      ref: React.ForwardedRef<HTMLButtonElement>
    ) => {
      const { t } = useTranslation()

      return (
        <button
          type="button"
          {...props}
          ref={ref}
          className={`global-search-button${
            isIconOnly ? " global-search-button--icon-only" : ""
          }${props.className ? ` ${props.className}` : ""}`}
          aria-label={
            isIconOnly && !props["aria-label"]
              ? t("GlobalSearch.SearchPlaceholder")
              : props["aria-label"]
          }
          data-input=""
        >
          <Icon name={IconName.SEARCH} />
          {!isIconOnly && (
            <span className="global-search-button__placeholder">
              {t("GlobalSearch.SearchPlaceholder")}
            </span>
          )}
        </button>
      )
    }
  )
)
